export default __webpack_public_path__ + "locales/pl/EmptyTrashDialog.json?hash=d37994ddb34de562afd95511b79d0892";